<div class="row" role="tabpanel" tabindex="0">
  <div class="col-12 col-lg-6">
    <now-wbsuche-lib-detail-kachel
      [icon]="'now-icon-notebook'"
      [id]="'inhalte'"
      [title]="'Weiterbildungsinhalte'"
      [collapseButtonText]="'zu den Weiterbildungsinhalten'"
      (collapsedChanged)="collapseStates.weiterbildungsinhalte = $event"
    >
      <now-wbsuche-lib-weiterbildungsinhalte
        [termin]="termin"
        [collapsed]="collapseStates.weiterbildungsinhalte"
      ></now-wbsuche-lib-weiterbildungsinhalte
    ></now-wbsuche-lib-detail-kachel>

    @if (showZugangsinformationen) {
      <now-wbsuche-lib-detail-kachel
        [icon]="'now-icon-door-open'"
        [id]="'zugang'"
        [title]="'Zugangsinformationen'"
        [collapseButtonText]="'zu den Zugangsinformationen'"
        ><now-wbsuche-lib-zugangsinformationen
          [termin]="termin"
        ></now-wbsuche-lib-zugangsinformationen
      ></now-wbsuche-lib-detail-kachel>
    }
  </div>
  <div class="col-12 col-lg-6">
    <now-wbsuche-lib-detail-kachel
      [id]="'weiterbildungsinfo'"
      [title]="'Weiterbildungs&shy;informationen'"
      [icon]="'now-icon-graduation-cap'"
      [collapseButtonText]="'zu den Weiterbildungsinformationen'"
      ><now-wbsuche-lib-weiterbildungsinformationen
        [termin]="termin"
      ></now-wbsuche-lib-weiterbildungsinformationen
    ></now-wbsuche-lib-detail-kachel>
  </div>
</div>
